import { Utilities } from "../../../utils/utilities";
import { ReadAccess } from "../General/AccessData";
import { CreatedByData } from "../General/CreatedByData";
import { FirebaseData } from "../General/FirebaseData";
import { LocalData } from "../General/LocalData";
import { RelativeData } from "../General/RelativeData";
import { UserData } from "../User/UserData";

export class ActivityData extends FirebaseData {
  title = "";
  readAccess: ReadAccess = {};
  responsibleUser?: UserData;
  isDone = false;
  relatives: Record<string, RelativeData> = {};
  startDate?: Date;

  markedDoneBy?: CreatedByData;

  setup(data: any) {
    if (this.isValidObject(data.markedDoneBy)) {
      this.markedDoneBy = new CreatedByData(data.markedDoneBy);
    }

    this.title = typeof data.title === "string" ? data.title : "";
    this.responsibleUser = typeof data.responsibleUserID === "string" ? LocalData.users.addData(data.responsibleUserID) : undefined;
    this.isDone = typeof data.isDone === "boolean" ? data.isDone : false;
    this.startDate = Utilities.getDateFromTimestamp(data.startDate);

    this.readAccess = Utilities.getReadAccess(data.readAccess);

    this.relatives = {};
    if (typeof data.relatives === "object") {
      for (const relativeID of Object.keys(data.relatives)) {
        this.relatives[relativeID] = new RelativeData(relativeID, data.relatives[relativeID]);
      }
    }

    super.setup(data);
  }
}

export interface MemberVisibility {
  hidden: boolean;
  visible: boolean;
}

